import { UpdateLicenseTypeComponent } from './update-license-type/update-license-type.component'
import { CreateLicenseTypeComponent } from './create-license-type/create-license-type.component'
import { LicenseTypesComponent } from './license-types.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const licenseTypesRoutes: Routes = [
  {
    path: 'admin/license-types',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: LicenseTypesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateLicenseTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateLicenseTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
